import { defineMessages } from 'react-intl-next';

export const sharedI18n = defineMessages({
	serverErrorMessageTitle: {
		id: 'confluence-analytics.server-error-message.title',
		defaultMessage: 'We couldn’t retrieve your data.',
		description:
			'Generic error message shown on sections (i.e., chart, card, or table) and flags, if there is an issue retrieving data from the server.',
	},
	serverErrorMessageDescription: {
		id: 'confluence-analytics.server-error-message.description',
		defaultMessage: 'Please reload or contact your site administrator.',
		description:
			'Generic error message shown on sections (i.e., chart, card, or table) and flags, if there is an issue retrieving data from the server.',
	},
	serverErrorExpandedDescription: {
		id: 'confluence-analytics.server-error-message.expanded-description',
		defaultMessage: '(Error: {errorMessage})',
		description:
			'Expanded error message shown in the flag, along with the actual error message returned from server.',
	},

	// Filters
	resetAllButtonText: {
		id: 'confluence-analytics.filters.reset-all-button-text',
		defaultMessage: 'Reset all',
		description: 'Button title which resets all filters applied.',
	},
	dateOption7D: {
		id: 'confluence-analytics.filters.date-option-7D',
		defaultMessage: '7D',
		description: 'Title for the filter button that changes the UI display to 7 day view.',
	},
	dateOption1M: {
		id: 'confluence-analytics.filters.date-option-1M',
		defaultMessage: '1M',
		description: 'Title for the filter button that changes the UI display to 1 month view.',
	},
	dateOption3M: {
		id: 'confluence-analytics.filters.date-option-3M',
		defaultMessage: '3M',
		description: 'Title for the filter button that changes the UI display to 3 months view.',
	},
	dateOptionYTD: {
		id: 'confluence-analytics.filters.date-option-YTD',
		defaultMessage: 'YTD',
		description: 'Title for the filter button that changes the UI display to year to date view.',
	},
	dateOptionAllTime: {
		id: 'confluence-analytics.filters.date-option-all-time',
		defaultMessage: 'All-time',
		description: 'Title for the filter button that changes the UI display to all time view.',
	},
	dateOptionCustom: {
		id: 'confluence-analytics.filters.date-option-custom',
		defaultMessage: 'Custom date range',
		description:
			'Title for the filter button that changes the UI display to a custom date range by customizing the start and end dates.',
	},
	dateOption7DExpanded: {
		id: 'confluence-analytics.filters.date-option-7D-expanded-form',
		defaultMessage: 'Last 7 days',
		description: 'Expanded form of 7D to display in a tooltip.',
	},
	dateOption1MExpanded: {
		id: 'confluence-analytics.filters.date-option-1M-expanded-form',
		defaultMessage: 'Last 1 month',
		description: 'Expanded form of 1M to display in a tooltip.',
	},
	dateOption3MExpanded: {
		id: 'confluence-analytics.filters.date-option-3M-expanded-form',
		defaultMessage: 'Last 3 months',
		description: 'Expanded form of 3M to display in a tooltip.',
	},
	dateOptionYTDExpanded: {
		id: 'confluence-analytics.filters.date-option-YTD-expanded-form',
		defaultMessage: 'Year to date',
		description: 'Expanded form of YTD to display in a tooltip.',
	},
	dateOptionAllTimeOneYearDateLimit: {
		id: 'confluence-analytics.filters.date-option-all-time-expanded-form.one-year-limit',
		defaultMessage: 'Starting from {startDate} (Data available for up to 1 year.)',
		description:
			'The message displayed when the user hovers the "All-time" date range and the data is limited because of the one year limit.',
	},
	dateOptionAllTimeCreationDateLimit: {
		id: 'confluence-analytics.filters.date-option-all-time-expanded-form.creation-date-limit',
		defaultMessage: 'Starting from {startDate} (Creation date.) ',
		description:
			'The message displayed when the user hovers the "All-time" date range and the data is limited because of the creation date limit.',
	},
	// Site analytics
	exportCSVButtonTitle: {
		id: 'confluence-analytics.export-csv-button-title',
		defaultMessage: 'Export as CSV',
		description:
			'Title for the "Export as CSV" button, which downloads all table data in CSV format.',
	},
	spaceIconLabel: {
		id: 'confluence-analytics.popular-spaces-card.space-icon-label',
		defaultMessage: 'Space logo for {spaceName}',
		description: 'Aria label text for any space logo on the popular spaces card',
	},
	userSearchPlaceholder: {
		id: 'confluence-analytics.users-table.user-search-placeholder',
		defaultMessage: 'Search users',
		description:
			'Placeholder text for the search textfield where users can filter the User Activity table by user names.',
	},
});
